import { useEffect, useState } from "react";

function useMediaQuery(query: `(${string})`) {
  const [matches, setMatches] = useState(
    () => window?.matchMedia(query).matches,
  );

  useEffect(() => {
    const mediaQueryList = window?.matchMedia(query);
    const listener = (event: MediaQueryListEvent) => setMatches(event.matches);

    mediaQueryList.addEventListener("change", listener);
    return () => mediaQueryList.removeEventListener("change", listener);
  }, [query]);

  return matches;
}

export default useMediaQuery;
